__turbopack_context__.v({
  "block-img": "eBh-jW_block-img",
  "story-blocks-container": "eBh-jW_story-blocks-container",
  "story-blocks-grid": "eBh-jW_story-blocks-grid",
  "story-blocks-item": "eBh-jW_story-blocks-item",
  "story-blocks-item-author": "eBh-jW_story-blocks-item-author",
  "story-blocks-item-content": "eBh-jW_story-blocks-item-content",
  "story-blocks-item-img": "eBh-jW_story-blocks-item-img",
  "story-blocks-item-title": "eBh-jW_story-blocks-item-title",
});
